import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [
        {
            path: "/",
            name: "bi-landing",
            component: () => import(/* webpackChunkName: "bi-landing"*/ "@v/landing"),
            meta: {
                group: "nonfiction",
                requiresAuth: false,
                allowsLoggedIn: true,
                requiresSubscription: false,
                allowsSubscribed: true
            }
        },
        {
            path: "/discover",
            name: "bi-discover",
            component: () => import(/* webpackChunkName: "bi-discover"*/ "@v/discover"),
            meta: {
                group: "nonfiction",
                requiresAuth: false,
                allowsLoggedIn: true,
                requiresSubscription: false,
                allowsSubscribed: true
            }
        },
        {
            path: "/about-us",
            name: "insight-about-us",
            component: () => import(/* webpackChunkName: "book-insight"*/ "@v/about-us/"),
            meta: {
                group: "nonfiction",
                requiresAuth: false,
                allowsLoggedIn: true,
                requiresSubscription: false,
                allowsSubscribed: true
            }
        },
        {
            path: "/:slug",
            name: "book-insight",
            component: () => import(/* webpackChunkName: "book-insight"*/ "@v/book-insight"),
            meta: {
                group: "nonfiction",
                requiresAuth: false,
                allowsLoggedIn: true,
                requiresSubscription: false,
                allowsSubscribed: true
            }
        },
        {
            path: "/:slug/reading-mode",
            name: "book-insight-reader",
            component: () => import(/* webpackChunkName: "book-insight-reader"*/ "@v/book-insight"),
            meta: {
                group: "nonfiction",
                requiresAuth: false,
                allowsLoggedIn: true,
                requiresSubscription: false,
                allowsSubscribed: true
            }
        },
        {
            path: "/404",
            name: "404",
            component: () => import(/* webpackChunkName: "404"*/ "./views/404.vue"),
            meta: {
                group: "hibooks",
                requiresAuth: false,
                allowsLoggedIn: true,
                requiresSubscription: false,
                allowsSubscribed: true
            }
        },
        {
            path: "*",
            name: "404-not-found",
            component: () => import(/* webpackChunkName: "404"*/ "./views/404"),
            meta: {
                group: "hibooks",
                requiresAuth: false,
                allowsLoggedIn: true,
                requiresSubscription: false,
                allowsSubscribed: true
            }
        }
    ]
});

export default router;
